module.exports = __webpack_public_path__ + "static/arrow_3_xl-30667961a8c25f85229febe717409739.png";